export default __webpack_public_path__ + "static/media/my_location.094f11f1.svg";